import {
	RecycleBinFilesViewType,
	FileWithShare,
} from "@/lib/supabase/supabaseTypes";
import { PdfTemplateType } from "../../pdf-templates/document-template.types";

const INVOICE_FILE_TYPES = [
	PdfTemplateType.AKONTORECHNUNG,
	PdfTemplateType.BARZAHLUNGSQUITTUNG,
	PdfTemplateType.KARTENZAHLUNGSQUITTUNG,
	PdfTemplateType.RECHNUNG,
	PdfTemplateType.SAMMELRECHNUNG,
];

export const isInvoiceFile = (
	file: RecycleBinFilesViewType | FileWithShare
) => {
	const fileType = (file.meta_data as { pdf_template_type: string })
		?.pdf_template_type;
	return fileType && INVOICE_FILE_TYPES.includes(fileType as PdfTemplateType);
};

export const isSpecificFile = (
	file: RecycleBinFilesViewType | FileWithShare,
	specificFileTypes: PdfTemplateType[]
) => {
	const fileType = (file.meta_data as { pdf_template_type: string })
		?.pdf_template_type;
	return fileType && specificFileTypes.includes(fileType as PdfTemplateType);
};
